import React from 'react';
import { useSearchParams, Link } from "react-router-dom";

export const Odemeeror = () => {
    const [searchParams] = useSearchParams();
    const merchantOid = searchParams.get("merchant_oid");

    return (
        <div className="container text-center my-5">
            <h2 className="text-danger mb-3">Ödeme Başarısız</h2>
            <p>Ödeme işlemi tamamlanamadı veya iptal edildi. Lütfen tekrar deneyiniz.</p>
            {merchantOid && (
                <p className="text-muted small">Sipariş numarası: <b>{merchantOid}</b></p>
            )}
            <Link to="/profile" className="btn btn-primary mt-3">Profile Dön</Link>
        </div>
    );
};

export default Odemeeror;
